export function isString<T>(payment: string | T | null): payment is string {
  return payment != null && typeof payment === "string";
}
